import VirtualClassSVG from "@design-system/ui-icons/vanilla/VirtualClass"
import { createIcon } from "../createIcon"

export const VirtualClassIcon = createIcon(VirtualClassSVG)
